<template>
  <div class="userLogin-box">
    <!--操作栏-->
    <div class="action-bar">
      <el-date-picker
        v-model="time"
        type="datetimerange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        size="small"
        @change="changeTime"
      ></el-date-picker>

      <el-button type="primary" size="small" @click="getUserTody('status')"
        >搜索</el-button
      >
    </div>
    <!--表格数据-->
    <el-table
      max-height="650"
      :data="tableData"
      style="width: 100%"
      border
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
    >
      <el-table-column
        prop="date"
        label="日期"
        align="center"
        width="180"
        fixed
      >
        <template slot-scope="scope">
          <span>{{ scope.row.date | changeDate }}</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="newUserCount"
        label="新增用户数"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          <span>{{ (scope.row.newUserCount || 0) | fixed2 | numFormat }}</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="bindUserCount"
        label="绑定用户数"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          <span>{{ (scope.row.bindUserCount || 0) | fixed2 | numFormat }}</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="newBindUserCount"
        label="新增绑定用户数"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          <span>{{
            (scope.row.newBindUserCount || 0) | fixed2 | numFormat
          }}</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="visitUserCount"
        label="今日活跃用户"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          <span>{{
            (scope.row.visitUserCount || 0) | fixed2 | numFormat
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="sumUserCount"
        label="用户数合计(Σ/个)"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          <span>{{ (scope.row.sumUserCount || 0) | fixed2 | numFormat }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="sumBindUserCount"
        label="绑定用户数合计(Σ/个)"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          <span>{{
            (scope.row.sumBindUserCount || 0) | fixed2 | numFormat
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="sumVisitUserCount"
        label="访问数合计(Σ/次)"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          <span>{{
            (scope.row.sumVisitUserCount || 0) | fixed2 | numFormat
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="aveVisitUserCount"
        label="平均访问用户数(次/日)"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          <span>{{
            (scope.row.aveVisitUserCount || 0) | fixed2 | numFormat
          }}</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="iosRetainUserRate2Day"
        label="ios次日留存率"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.iosRetainUserRate2Day || '未知' }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="andRetainUserRate2Day"
        label="android次日留存率"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.andRetainUserRate2Day || '未知' }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="h5RetainUserRate2Day"
        label="h5次日留存率"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.h5RetainUserRate2Day || '未知' }}</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="retainUserRate2Day"
        label="次日留存率"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.retainUserRate2Day || '未知' }}</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="retainUserRate3Day"
        label="3日留存率"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.retainUserRate3Day || '未知' }}</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="retainUserRate7Day"
        label="7日留存率"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.retainUserRate7Day || '未知' }}</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="retainUserRate15Day"
        label="15日留存率"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.retainUserRate15Day || '未知' }}</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="retainUserRate30Day"
        label="30日留存率"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.retainUserRate30Day || '未知' }}</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="payAmount"
        label="消费金币"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          <span>{{ (scope.row.payAmount || 0) | fixed2 | numFormat }}</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="payVidAmount"
        label="视频消费金币"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          <span>{{ (scope.row.payVidAmount || 0) | fixed2 | numFormat }}</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="payVipAmount"
        label="购买VIP金币"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          <span>{{ (scope.row.payVipAmount || 0) | fixed2 | numFormat }}</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="payVipUserCount"
        label="购买VIP人数"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          <span>{{
            (scope.row.payVipUserCount || 0) | fixed2 | numFormat
          }}</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="payUserCount"
        label="消费人数"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          <span>{{ (scope.row.payUserCount || 0) | fixed2 | numFormat }}</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="newAndPayUserCount"
        label="新增并消费人数"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          <span>{{
            (scope.row.newAndPayUserCount || 0) | fixed2 | numFormat
          }}</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="sumPayAmount"
        label="消费金币合计(Σ/个)"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          <span>{{ (scope.row.sumPayAmount || 0) | fixed2 | numFormat }}</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="avePayAmount"
        label="平均消费金币(个/日)"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          <span>{{ (scope.row.avePayAmount || 0) | fixed2 | numFormat }}</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="merchantRechargeAmount"
        label="商人充值额度(元)"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          <span>{{
            (scope.row.merchantRechargeAmount / 100 || 0) | fixed2 | numFormat
          }}</span>
        </template>
      </el-table-column>
      -->

      <el-table-column
        prop="onlineRechargeAmount"
        label="在线用户充值金额(元)"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          <span>{{
            (scope.row.onlineRechargeAmount / 100 || 0) | fixed2 | numFormat
          }}</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="totalRechargeAmount"
        label="总充值金额(元)"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          <span>{{
            (scope.row.totalRechargeAmount / 100 || 0) | fixed2 | numFormat
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="merchantRechargeAmount"
        label="商人值金额(元)"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          <span>{{
            (scope.row.merchantRechargeAmount / 100 || 0) | fixed2 | numFormat
          }}</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="rechargeUserCount"
        label="充值用户数"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          <span>{{
            (scope.row.rechargeUserCount || 0) | fixed2 | numFormat
          }}</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="newAndRechargeUserCount"
        label="新增充值用户数"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          <span>{{
            (scope.row.newAndRechargeUserCount || 0) | fixed2 | numFormat
          }}</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="arpu"
        label="每用户平均收入(元/人)"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          <span>{{ (scope.row.arpu / 100 || 0) | fixed2 | numFormat }}</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="arppu"
        label="每充值用户平均收益(元/人)"
        align="center"
        width="220"
      >
        <template slot-scope="scope">
          <span>{{ (scope.row.arppu / 100 || 0) | fixed2 | numFormat }}</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="sumRechargeAmount"
        label="充值金额合计(Σ/元)"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          <span>{{
            (scope.row.sumRechargeAmount / 100 || 0) | fixed2 | numFormat
          }}</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="aveRechargeAmount"
        label="平均充值金额(元/日)"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          <span>{{
            (scope.row.aveRechargeAmount / 100 || 0) | fixed2 | numFormat
          }}</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="goldWithdrawAmount"
        label="金币提现金额(元)"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          <span>{{
            (scope.row.goldWithdrawAmount / 100 || 0) | fixed2 | numFormat
          }}</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="proxyWithdrawAmount"
        label="全民代理提现金额(元)"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          <span>{{
            (scope.row.proxyWithdrawAmount / 100 || 0) | fixed2 | numFormat
          }}</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="newVideoCount"
        label="新增短视频数"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          <span>{{ (scope.row.newVideoCount || 0) | fixed2 | numFormat }}</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="playUserCount"
        label="播放视频人数"
        align="center"
        width="120"
      >
        <template slot-scope="scope">
          <span>{{ (scope.row.playUserCount || 0) | fixed2 | numFormat }}</span>
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination
      :page-sizes="[10, 15, 20, 25]"
      :current-page="params.pageNumber"
      :page-size="params.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      background
      v-if="total > 10"
      @size-change="changeSize"
      @current-change="changeCurrent"
    ></el-pagination>
  </div>
</template>
<script>
import { changeTime } from "@/utils/global";
import API from "@/api";
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      // 时间数据绑定字段
      time: "",
      tableData: [],
      total: 0,
      // 表格数据加载动画
      loading: false,
      // 用户今日统计列表请求参数
      params: {
        pageNumber: 1,
        pageSize: 10,
        startTime: null,
        endTime: null,
      },
    };
  },
  computed: {
    //映射模拟倍率
    ...mapGetters(["expansionFactor"]),
  },
  created() {
    this.getUserTody();
    // this.getUserTody()
    //     setInterval(() => {
    //   this.getUserTody()
    // }, 20000);
  },
  methods: {
    //映射模拟倍率方法
    ...mapActions(["setBeilv"]),
    // 时间触发回调
    changeTime(time) {
      if (time) {
        this.params.startTime = changeTime(time[0]) || null;
        this.params.endTime = changeTime(time[1]) || null;
      } else {
        this.params.startTime = null;
        this.params.endTime = null;
      }
      this.getUserTody("status");
    },
    // 请求用户今日统计列表数据
    getUserTody(type) {
      if (type === "status") {
        this.params.pageNumber = 1;
      }
      this.loading = true;
      API.getUserTody({ ...this.params, expansionFactor: this.expansionFactor })
        .then((res) => {
          this.loading = false;
          this.setBeilv(this.expansionFactor);
          if (res.code === 200 && res.data.list) {
            this.tableData = res.data.list;
            this.total = res.data.total;
          } else {
            this.tableData = [];
            this.total = 0;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 分页条数改变回调
    changeSize(size) {
      this.params.pageSize = size;
      this.getUserTody();
    },
    // 分页页码改变回调
    changeCurrent(number) {
      this.params.pageNumber = number;
      this.getUserTody();
    },
  },
};
</script>
